var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.loading)?_c('div',[_c('div',{staticStyle:{"text-align":"center","margin":"100px"}},[_c('font-awesome-icon',{attrs:{"icon":"cog","spin":"","size":"5x"}}),_c('p',[_vm._v("This may take a while")])],1)]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }